export default "__VITE_ASSET__Dg3ypB4U__"